import React, { Component, PropTypes } from 'react';
import './Metapod.scss';

class Metapod extends Component {
  render() {
    return (
      <div className="pokemon">
        <div className="metapod">
          <div className="head">

          </div>
          <div className="body">

          </div>
        </div>
      </div>
    );
  }
}

export default Metapod;



/** WEBPACK FOOTER **
 ** ./source/011-metapod/Metapod.js
 **/